
const animationSpeed = 500;
const millisecondsInSecond = 1000;

export default function showNotificationCentered(el, duration, callback) {
	const notification = $('<div class="notification" />');
	notification.append($('<div class="overlay"></div>'));
	el.addClass('displaynone animationnone');
	notification.append(el);
	Screen.elements.notifications.append(notification);

	// position vertically centered
	const elHeight = parseInt(el.height());
	const winHeight = parseInt($(window).height());
	let marginTop = (winHeight / 2) - (elHeight / 2);
	if (marginTop < 0) {
		marginTop = 0;
	}
	el.css('marginTop', marginTop).removeClass('displaynone animationnone');

	const onEnd = () => {
		el.addClass('animationnone');
		notification.animate({ opacity: 0 }, animationSpeed, function() {
			$(this).remove();
			callback?.();
		});
	};

	// animate out
	const endTimeout = setTimeout(onEnd, duration * millisecondsInSecond);

	return () => {
		clearTimeout(endTimeout);
		onEnd();
	};
}
